/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * AUTO-GENERATED REACT QUERY HOOKS - DO NOT EDIT
 * Generated from: MerchantTransactionsContract
 */

import { merchanttransactionsApi } from '../api/merchanttransactions.api';
import { createPaginatedQueryHook } from './base.hooks';
import { queryKeys } from './query-keys';
import type { ListTransactionsQueryType, ListTransactionsParamsType, ListTransactionsResponseType } from '@zlinkx/shared-v2';
import type { HookOptions, MutationHookReturn, QueryHookReturn } from '@/types/hook-generated.types';

export const useListTransactions = createPaginatedQueryHook<ListTransactionsResponseType['data'][number], { merchantId: ListTransactionsParamsType['merchantId']; query?: ListTransactionsQueryType }>(
  ({ merchantId, query }) => merchanttransactionsApi.listTransactions(merchantId, query),
  ({ merchantId, query }) => queryKeys.merchanttransactions.listTransactions(merchantId, query)
);